<template>
	<div class='poll col-12 mt-4'>
		<transition name='slide' mode='out-in'>
			<div class='poll__loading' key='loading' v-if='!drawPoll'>
				<loading-icon :dark='true'></loading-icon>
			</div>
			<div key='poll' v-else>
				<div class="d-flex flex-row justify-content-between align-items-center border-bottom border-green-lighter">
					<span class='h5 text-shadow mr-3'>{{ drawPoll.question }}</span>
					<span class="text-secondary pl-3">
						{{drawPoll.total_votes}}
						{{drawPoll.total_votes | $t('gifts_total_votes') }}
					</span>
				</div>
				

				<div class='poll__voting_view' v-if='view === "voting" && !drawPoll.has_voted'>
					<div class='poll__answers'>
						<div
							v-for='(answer, $index) in drawPoll.answers'
							class='poll__answer'
							:class='{ "poll__answer--selected" : answer === selected }'
							:key='"poll-answer-" + $index'
							@click='selected = answer'
						>
							{{answer.answer}}
						</div>
					</div>
					<div class='poll__buttons'>						
						<loading-button
							class='btn btn-primary btn-sm'
							id="vote-loading"
							:class='{ "button--disabled": !selected }'
							:loading='loading'
							@click='vote'
						>{{ $t('gifts_vote_now') }}</loading-button>
						<button
							class='btn btn-outline-secondary btn-sm ml-3'
							@click='view = "results"'
						>{{ $t('gifts_view_results') }}</button>
					</div>
				</div>

				<div class='poll__results_view' v-else>
					<div class='poll__results'>
						<div class='poll__result' :key='"poll-result-" + $index' v-for='(result, $index) in drawPoll.answers'>
							<div>
								<span class="h6 text-primary">{{result.answer}}</span>
								<span class='poll__result__info'>
									-
									{{result.poll_votes.length}} {{result.poll_votes.length | pluralize('vote')}}
									( {{ Math.ceil(result.percent * 100)/100  || 0 }}% )
								</span>
							</div>
							<div class='poll__result__bar_outer'></div>
							<div class='poll__result__bar' :style='{ "width": (result.percent || 0) + "%" }'></div>
						</div>
					</div>

					<div class='poll__buttons' v-if='!drawPoll.has_voted'>
						<button class='button button--thin_text' @click='view = "voting"'>{{ $t('gifts_back') }}</button>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import LoadingIcon from './LoadingIcon'
	import LoadingButton from './LoadingButton'
	import {apiDomain} from '../config'
	import AjaxErrorHandler from '../assets/js/errorHandler'

	export default {
		name: 'ThreadPoll',
		props: ['poll'],
		components: { LoadingIcon, LoadingButton },
		data () {
			return {
				drawPoll: this.poll,				
				view: 'voting',
				selected: null,
				loading: false
			}
		},
		methods: {
			vote () {
				
				if(!this.selected){ return; }

				this.loading = true;
				let oo = this;

				this.axios
					.post(`${apiDomain}/api/v1/poll/` + this.selected.discussion_id, 
					{ 
						poll_answer: this.selected.answer, 
						poll_answer_id: this.selected.id, 
						poll_question_id: this.selected.poll_questions_id, 
					},
					{ 
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`} 
					}
					)
					.then(res => {
						oo.drawPoll = res.data.content
						oo.loading = false
						oo.view = 'results'
					})
					.catch(e => {
						this.loading = false;
						this.$router.push('/');
						AjaxErrorHandler(this.$store)(e)
					})
			}
		},
		mounted () {
			console.log(this.poll);			
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/scss/variables.scss';

	.poll {
		padding: 1rem;
		position: relative;
		margin-bottom: 2rem;
		border: 1px solid rgba(0, 255, 126, 0.25);

		@at-root #{&}__loading {
			@include loading-overlay(transparent);
			opacity: 1;
		}

		@at-root #{&}__question {
			font-weight: bold;
			font-size: 1.125rem;
			word-break: break-all;
		}

		@at-root #{&}__answers, #{&}__results {
			margin: 1rem 0;
		}

		@at-root #{&}__answer {
			padding: 0.5rem 0.625rem;
			margin: 0.5rem 0;
			border: 1px solid rgba(0, 255, 126, 0.25);
			border-radius: 0.125rem;
			cursor: pointer;
			transition: all 0.2s;
			position: relative;
			overflow: hidden;
			text-overflow: ellipsis;

			&::after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				height: 100%;
				background-color: #00ff7f;
				width: 0rem;
				opacity: 0;
				border-radius: 0.125rem 0 0 0.125rem;

				transition: all 0.2s;
			}

			@at-root #{&}--selected {
				font-weight: bold;

				&::after {
					opacity: 1;
					width: 0.3rem;
				}
				&:hover {
					box-shadow: none;
				}
			}
		}
		@at-root #{&}__buttons {
			> * {
				margin-right: 0.5rem;
			}
		}

		@at-root #{&}__total_votes {
			color: $color__text--secondary;
			font-style: italic;
		}
		@at-root #{&}__result {
			margin: 0.5rem 0;
			word-break: break-all;

			@at-root #{&}__bar_outer {
				width: 100%;
				height: 1rem;
				margin-top: 0.25rem;
				border: thin solid #00ff7f;

			}
			@at-root #{&}__bar {
				background-color: #00ff7f;
				height: 1rem;
				position: relative;
				top: -1rem;
				margin-bottom: -1rem;
			}
		}
	}

	@include thread_mobile_breakpoint ('.poll');
</style>
<style>
#vote-loading .loading_icon.loading_button__icon{
	display: inline-block;
	left: 10px;
}
</style>